import DropdownSelection from 'app/models/dropdown_selection';

export default DropdownSelection.extend({

  initialize({
    dropdowns, dependentSelection, paramKey, label, defaultChoices,
  }) {
    this.dropdowns = dropdowns;
    this.dependentSelection = dependentSelection;
    this.paramKey = paramKey;
    this.label = label;
    this.defaultChoices = defaultChoices;
    this.setDefaultCurrentChoice();
    this.listenTo(this.dependentSelection, 'change', this.setDefaultCurrentChoice);
  },

  setDefaultCurrentChoice() {
    const choices = this.getDynamicSelectionChoices();
    this.set('currentChoice', choices[0], { silent: true });
  },

  setCurrentChoice(val) {
    const dynamicSelectionChoices = this.getDynamicSelectionChoices();
    this.setChoiceIfValid(dynamicSelectionChoices, val, { silent: true });
  },

  getDynamicSelectionChoices() {
    const dynamicKey = this.dependentSelection.get('currentChoice').option;
    const dynamicSelection = this.dropdowns[dynamicKey];
    return dynamicSelection ? dynamicSelection.choices : this.defaultChoices;
  },
});



// WEBPACK FOOTER //
// ./app/models/dynamic_dropdown_selection.js